var _slicedToArray = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectSpread = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _classCallCheck = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

/**
 * Mixin with profile-related helpers (for people and groups)
 */
var util = require('util');

var _require = require('./utils'),
    ensure_timestamp = _require.ensure_timestamp;

function merge_modifiers(data, modifiers) {
  if (modifiers) {
    if (modifiers.$ignore_alias) {
      data.$ignore_alias = modifiers.$ignore_alias;
    }

    if (modifiers.$ignore_time) {
      data.$ignore_time = modifiers.$ignore_time;
    }

    if (modifiers.hasOwnProperty("$ip")) {
      data.$ip = modifiers.$ip;
    }

    if (modifiers.hasOwnProperty("$time")) {
      data.$time = ensure_timestamp(modifiers.$time);
    }
  }

  return data;
}

;
exports.merge_modifiers = merge_modifiers;

exports.ProfileHelpers = function () {
  var Base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object;
  return (
    /*#__PURE__*/
    function (_Base) {
      "use strict";

      _inherits(_class, _Base);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "_set",
        value: function _set(prop, to, modifiers, callback, _ref) {
          var identifiers = _ref.identifiers,
              _ref$set_once = _ref.set_once,
              set_once = _ref$set_once === void 0 ? false : _ref$set_once;
          var $set = {};

          if (typeof prop === 'object') {
            if (typeof to === 'object') {
              callback = modifiers;
              modifiers = to;
            } else {
              callback = to;
            }

            $set = prop;
          } else {
            $set[prop] = to;

            if (typeof modifiers === 'function' || !modifiers) {
              callback = modifiers;
            }
          }

          var data = _objectSpread({
            '$token': this.token
          }, identifiers);

          var set_key = set_once ? "$set_once" : "$set";
          data[set_key] = $set;

          if ('ip' in $set) {
            data.$ip = $set.ip;
            delete $set.ip;
          }

          if ($set.$ignore_time) {
            data.$ignore_time = $set.$ignore_time;
            delete $set.$ignore_time;
          }

          data = merge_modifiers(data, modifiers);

          if (this.config.debug) {
            console.log("Sending the following data to Mixpanel (".concat(this.endpoint, "):"));
            console.log(data);
          }

          this.mixpanel.send_request({
            method: "GET",
            endpoint: this.endpoint,
            data: data
          }, callback);
        }
      }, {
        key: "_delete_profile",
        value: function _delete_profile(_ref2) {
          var identifiers = _ref2.identifiers,
              modifiers = _ref2.modifiers,
              callback = _ref2.callback;

          var data = _objectSpread({
            '$delete': '',
            '$token': this.token
          }, identifiers);

          if (typeof modifiers === 'function') {
            callback = modifiers;
          }

          data = merge_modifiers(data, modifiers);

          if (this.config.debug) {
            console.log("Deleting profile ".concat(JSON.stringify(identifiers)));
          }

          this.mixpanel.send_request({
            method: "GET",
            endpoint: this.endpoint,
            data: data
          }, callback);
        }
      }, {
        key: "_remove",
        value: function _remove(_ref3) {
          var identifiers = _ref3.identifiers,
              data = _ref3.data,
              modifiers = _ref3.modifiers,
              callback = _ref3.callback;
          var $remove = {};

          if (typeof data !== 'object' || util.isArray(data)) {
            if (this.config.debug) {
              console.error("Invalid value passed to #remove - data must be an object with scalar values");
            }

            return;
          }

          for (var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++) {
            var _ref6 = _Object$entries[_i];

            var _ref5 = _slicedToArray(_ref6, 2);

            var key = _ref5[0];
            var val = _ref5[1];

            if (typeof val === 'string' || typeof val === 'number') {
              $remove[key] = val;
            } else {
              if (this.config.debug) {
                console.error("Invalid argument passed to #remove - values must be scalar");
                console.error("Passed " + key + ':', val);
              }

              return;
            }
          }

          if (Object.keys($remove).length === 0) {
            return;
          }

          data = _objectSpread({
            '$remove': $remove,
            '$token': this.token
          }, identifiers);

          if (typeof modifiers === 'function') {
            callback = modifiers;
          }

          data = merge_modifiers(data, modifiers);

          if (this.config.debug) {
            console.log("Sending the following data to Mixpanel (".concat(this.endpoint, "):"));
            console.log(data);
          }

          this.mixpanel.send_request({
            method: "GET",
            endpoint: this.endpoint,
            data: data
          }, callback);
        }
      }, {
        key: "_union",
        value: function _union(_ref7) {
          var identifiers = _ref7.identifiers,
              data = _ref7.data,
              modifiers = _ref7.modifiers,
              callback = _ref7.callback;
          var $union = {};

          if (typeof data !== 'object' || util.isArray(data)) {
            if (this.config.debug) {
              console.error("Invalid value passed to #union - data must be an object with scalar or array values");
            }

            return;
          }

          for (var _i2 = 0, _Object$entries2 = Object.entries(data); _i2 < _Object$entries2.length; _i2++) {
            var _ref10 = _Object$entries2[_i2];

            var _ref9 = _slicedToArray(_ref10, 2);

            var key = _ref9[0];
            var val = _ref9[1];

            if (util.isArray(val)) {
              var merge_values = val.filter(function (v) {
                return typeof v === 'string' || typeof v === 'number';
              });

              if (merge_values.length > 0) {
                $union[key] = merge_values;
              }
            } else if (typeof val === 'string' || typeof val === 'number') {
              $union[key] = [val];
            } else {
              if (this.config.debug) {
                console.error("Invalid argument passed to #union - values must be a scalar value or array");
                console.error("Passed " + key + ':', val);
              }
            }
          }

          if (Object.keys($union).length === 0) {
            return;
          }

          data = _objectSpread({
            '$union': $union,
            '$token': this.token
          }, identifiers);

          if (typeof modifiers === 'function') {
            callback = modifiers;
          }

          data = merge_modifiers(data, modifiers);

          if (this.config.debug) {
            console.log("Sending the following data to Mixpanel (".concat(this.endpoint, "):"));
            console.log(data);
          }

          this.mixpanel.send_request({
            method: "GET",
            endpoint: this.endpoint,
            data: data
          }, callback);
        }
      }, {
        key: "_unset",
        value: function _unset(_ref11) {
          var identifiers = _ref11.identifiers,
              prop = _ref11.prop,
              modifiers = _ref11.modifiers,
              callback = _ref11.callback;
          var $unset = [];

          if (util.isArray(prop)) {
            $unset = prop;
          } else if (typeof prop === 'string') {
            $unset = [prop];
          } else {
            if (this.config.debug) {
              console.error("Invalid argument passed to #unset - must be a string or array");
              console.error("Passed: " + prop);
            }

            return;
          }

          var data = _objectSpread({
            '$unset': $unset,
            '$token': this.token
          }, identifiers);

          if (typeof modifiers === 'function') {
            callback = modifiers;
          }

          data = merge_modifiers(data, modifiers);

          if (this.config.debug) {
            console.log("Sending the following data to Mixpanel (".concat(this.endpoint, "):"));
            console.log(data);
          }

          this.mixpanel.send_request({
            method: "GET",
            endpoint: this.endpoint,
            data: data
          }, callback);
        }
      }, {
        key: "token",
        get: function get() {
          return this.mixpanel.token;
        }
      }, {
        key: "config",
        get: function get() {
          return this.mixpanel.config;
        }
      }]);

      return _class;
    }(Base)
  );
};